
<script>
  import { setContext } from 'svelte';
  import Player from './Player.svelte';
  import { mediaPlaylist, playerOn } from 'apps/imd/stores';

  export let app;
  setContext('app', app);

  const devMode = app.key('devMode');
  const player_enabled = app.feature('player');
  let show = false;

  $: {
    if (player_enabled && $playerOn) {
      show = true;
    }
    else if (show && !$playerOn) {
      requestAnimationFrame(() => {
        show = false;
        devMode && console.timeEnd('player off');
      });
    }
  }

</script>

<div class="ds-player-container container" class:show>
  {#if player_enabled}
    <Player media_playlist={mediaPlaylist} play={show} 
      on:media.loaded
      on:media.play
      on:playlist.loaded />
  {:else}
    <!-- DS Player not enabled - settings.feature.player -->
  {/if}
</div>

<style media="screen">
  .ds-player-container {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 10000;
  }

  .show {
    display: block;
  }
</style>
